module.exports = __webpack_public_path__ + "img/u246.ac18aab8.jpg";